import { render, staticRenderFns } from "./socre-box-edit.vue?vue&type=template&id=854b0a56"
import script from "./socre-box-edit.vue?vue&type=script&lang=js"
export * from "./socre-box-edit.vue?vue&type=script&lang=js"
import style0 from "./socre-box-edit.vue?vue&type=style&index=0&id=854b0a56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports